module.exports = __webpack_public_path__ + "static/media/impactEvaluationNotification.be8bae3a.svg";